import { __assign, __rest } from "tslib";
import { Select, VStack } from '@chakra-ui/react';
import React from 'react';
var OptionSelection = function (_a) {
    var options = _a.options, alignItems = _a.alignItems, wrapperProps = _a.wrapperProps, selectProps = __rest(_a, ["options", "alignItems", "wrapperProps"]);
    return (React.createElement(VStack, __assign({ alignItems: alignItems, w: '100%' }, wrapperProps),
        React.createElement(Select, __assign({ variant: 'filled' }, selectProps), options === null || options === void 0 ? void 0 : options.map(function (_a) {
            var value = _a.value, label = _a.label;
            return (React.createElement("option", { key: value, value: value !== null && value !== void 0 ? value : '' }, label));
        }))));
};
export default OptionSelection;
//# sourceMappingURL=OptionSelection.js.map